<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Stock Adjustment</a>
                  </li>
                  <li class="breadcrumb-item active">
                    <span v-if="adjust.id === null">New</span>
                    <span v-else>
                      {{ adjust.adjust_no }}
                    </span>
                  </li>
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="adjust_date" class="col-sm-3 col-form-label text-left">Date</label>
                    <div class="col-sm-9">
                      <datetime v-model="adjust.adjust_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="adjust.lock"></datetime>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="branch_no" class="col-sm-3 col-form-label text-left">Branch</label>
                    <div class="col-sm-9">
                        <select v-model="adjust.branch_no" id="branch_no" class="form-control" :disabled="adjust.lock">
                            <option v-for="b in brachList" :key="b.id" :value="b.branch_no">[{{ b.branch_no }}] {{ b.name }}</option>
                        </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="branch_no" class="col-sm-3 col-form-label text-left">Type</label>
                    <div class="col-sm-9">
                        <select v-model="adjust.type" id="type" class="form-control" :disabled="adjust.lock">
                          <option value="adjust">Adjust</option>
                          <option value="stock">Stock</option>
                        </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="ref_no" class="col-sm-3 col-form-label text-left">Ref No.</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="adjust.ref_no" :disabled="adjust.lock">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="adjust_notes" class="col-sm-3 col-form-label text-left">Notes</label>
                    <div class="col-sm-9">
                      <textarea class="form-control" v-model="adjust.adjust_notes" :disabled="adjust.lock"></textarea>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modalStockAdjustmentSerialNumber" data-backdrop="static" data-keyboard="false">Serial Number</button>
              </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-sm table-item table-hover">
                        <thead>
                            <th style="width: 25%">Product No.</th>
                            <th>Qty</th>
                            <th>Unit</th>
                            <th>Price</th>
                            <th>Serial Number</th>
                            <th>Warehouse</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="(oh, index) in getOnHands" :key="oh.id">
                              <td>
                                <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="oh.product_no" @input="setProduct(index)" :disabled="adjust.lock"/>
                              </td>
                              <td>
                                <input type="text" class="form-control" v-model="oh.qty" :disabled="adjust.lock"/>
                              </td>
                              <td>
                                  <select class="form-control" v-model="oh.uom_id" :disabled="adjust.lock">
                                    <option v-for="uo in oh.uomList" :key="uo.id">{{ uo.id }}</option>
                                  </select>
                              </td>
                              <td>
                                  <input type="text" class="form-control" v-model="oh.price" :disabled="adjust.lock"/>
                              </td>
                              <td>
                                  <input type="text" class="form-control" v-model="oh.serial_number" v-if="oh.canBarcode" :disabled="adjust.lock"/>
                                  <input type="text" class="form-control" v-model="oh.serial_number" v-else disabled="disabled"/>
                              </td>
                              <td>
                                <select class="form-control" v-model="oh.warehouse_no">
                                  <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no" :disabled="adjust.lock">{{ w.name }}</option>
                                </select>
                              </td>
                              <td><button type="button" class="btn btn-sm btn-danger" @click="remove(index)" v-if="adjust.lock === false"><i class="fa fa-trash"></i></button></td>
                          </tr>
                          <tr>
                              <td colspan="8">
                                <span style="color: blue; cursor: pointer;" @click="addNewLine" v-if="adjust.lock == false">Add Line</span>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-sm btn-primary pull-right" v-if="adjust.id === null" @click="save">Save</button>
          <button type="button" class="btn btn-sm btn-primary pull-right" v-else @click="update">Update</button>
          <button type="button" class="btn btn-sm btn-success pull-right" v-if="adjust.id !== null" @click="approve">Approve</button>
        </div>
      </div>
      <pre>{{ adjust }}</pre>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in adjust.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <StockAdjustmentModal @getSerialNumber="searchSerialNumber"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, inventoryUrl, stockAdjustmentUrl } from '../../../config'
import StockAdjustmentModal from '@/components/stock/adjust/StockAdjustmentModal.vue'

export default {
  name: 'StockAdjustmentForm',
  components: {
    StockAdjustmentModal
  },
  props: ['adjust'],
  data () {
    return {
      barcode: null,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  computed: {
    ...mapState({
      brachList: state => state.branches.branchList,
      productList: state => state.products.productListAll,
      uomList: state => state.uom.uomList,
      warehouseList: state => state.warehouses.warehouseList
    }),
    getOnHands: function () {
      return this.adjust.onhands
    },
    productselect: function () {
      var loop = []
      var array = this.productList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async approve () {
      await axios.get(stockAdjustmentUrl + '/approve/' + this.adjust.id, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'succses'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async save () {
      await axios.post(stockAdjustmentUrl, this.adjust, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async update () {
      await axios.put(stockAdjustmentUrl + '/' + this.adjust.id, this.adjust, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    remove: function (index) {
      var obj = this.adjust.onhands[index]
      if (obj.id !== undefined) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(stockAdjustmentUrl + '/on-hand/' + obj.id, { headers: getHeader() })
              .then(response => {
                this.adjust.onhands.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal(
                  'Error',
                  error.response.data.message,
                  'error'
                )
              })
            console.log('delete from database')
          }
        })
      } else {
        this.adjust.onhands.splice(index, 1)
      }
    },
    searchSerialNumber: function (value) {
      this.onBarcodeScanned(value)
    },
    onBarcodeScanned: function (barcode) {
      var check = this.adjust.onhands.find(d => d.serial_number === barcode)
      if (typeof check === 'undefined') {
        var data = {
          barcode: barcode
        }
        axios.post(inventoryUrl + '/serial-number', data, { headers: getHeader() })
          .then(response => {
            // console.log(response.data.data)
            var data = response.data.data
            var product = this.productList.find(d => d.product_no === data.product_no)
            var obj = {
              product_no: product.product_no,
              product: data.product.product_name,
              qty: 1,
              price: product.cost,
              on_hand_date: null,
              notes: null,
              warehouse_no: null,
              branch_no: null,
              uom_id: product.uom_id,
              adjust_no: null,
              serial_number: barcode,
              canBarcode: product.canBarcode,
              uomList: product.uomList
            }
            this.adjust.onhands.push(obj)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal(
              'Error',
              error.response.data.message,
              'error'
            )
          })
      }
    },
    addNewLine: function () {
      var obj = {
        product_no: null,
        product: null,
        qty: null,
        price: '0',
        on_hand_date: null,
        notes: null,
        warehouse_no: null,
        branch_no: null,
        uom_id: null,
        adjust_no: null,
        serial_number: null,
        canBarcode: false,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: null,
          active: null,
          cost: '0',
          price: '0'
        }]
      }
      this.adjust.onhands.push(obj)
    },
    setProduct: function (index) {
      var product = this.productList.find(d => d.product_no === this.adjust.onhands[index].product_no)
      this.adjust.onhands[index].qty = 1
      this.adjust.onhands[index].canBarcode = product.canBarcode
      this.adjust.onhands[index].uomList = product.uomList
      this.adjust.onhands[index].uom_id = product.uom_id
      this.adjust.onhands[index].price = product.cost
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
